export type TeamRankingZone = "none" | "playoffs" | "playIn" | "outside";

export const formatTeamRankingPercentage = (
  value: number | null | undefined,
) => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return "—";
  }

  return `${(value * 100).toFixed(1)}%`;
};

export const formatTeamRankingGamesBack = (
  value: number | null | undefined,
) => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return "—";
  }

  return value.toFixed(1);
};

export const getTeamRankingZone = ({
  maxPlayoffSeed,
  maxPlayoffSeedNoPlayIn,
  playIn,
  qualificationApplies,
  rank,
}: {
  maxPlayoffSeed: number;
  maxPlayoffSeedNoPlayIn: number;
  playIn: boolean;
  qualificationApplies: boolean;
  rank: number;
}): TeamRankingZone => {
  if (!qualificationApplies || rank <= 0 || maxPlayoffSeed <= 0) {
    return "none";
  }

  const directPlayoffSeed = playIn
    ? Math.max(0, Math.min(maxPlayoffSeedNoPlayIn, maxPlayoffSeed))
    : maxPlayoffSeed;
  if (rank <= directPlayoffSeed) {
    return "playoffs";
  }
  if (playIn && rank <= maxPlayoffSeed) {
    return "playIn";
  }

  return "outside";
};

type TeamRankingSeasonRecord = {
  gp?: number;
  lost?: number;
  otl?: number;
  tied?: number;
  won?: number;
};

export const getTeamRankingSeasonStarted = (
  records: readonly TeamRankingSeasonRecord[],
) =>
  records.some(
    (record) =>
      (record.gp ?? 0) > 0 ||
      (record.won ?? 0) > 0 ||
      (record.lost ?? 0) > 0 ||
      (record.tied ?? 0) > 0 ||
      (record.otl ?? 0) > 0,
  );
